import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Box, Grid, Hidden } from "@material-ui/core";
import Submit from "../../components/Submit";
import { useTranslation } from "react-i18next";
import ProfileView from "../../views/account/ProfileView";

const validationSchema = Yup.object().shape({
  first_name: Yup.string().required("Is required"),
  last_name: Yup.string().required("Is required"),
  email: Yup.string().required("Is required"),
});

const ProfileForm = ({ onSubmit = () => {}, initialValues }) => {
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit}>
          <Box
            mt={1}
            boxShadow={{ xs: 0, sm: 2 }}
            display="flex"
            flexDirection="column"
            p={2}
          >
            <ProfileView {...props} />
            <Box mt={2}>
              <Grid container spacing={2}>
                <Hidden xsDown>
                  <Grid item sm={10}></Grid>
                </Hidden>
                <Grid item xs={12} sm={2}>
                  <Submit {...props} title={t("register.button_save")} />
                </Grid>
              </Grid>
            </Box>
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default ProfileForm;
